import { render } from "./QuestionListItem.vue?vue&type=template&id=588b289f&scoped=true"
import script from "./QuestionListItem.vue?vue&type=script&lang=js"
export * from "./QuestionListItem.vue?vue&type=script&lang=js"

import "./QuestionListItem.vue?vue&type=style&index=0&id=588b289f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588b289f"]])

export default __exports__